module.exports = __webpack_public_path__ + "img/2024-10-16b_2.413c9051.jpg";